import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { CredentialsResult } from "../types";

export type UseCredentialsResult = {
  isLoading: boolean;
  error: unknown;
  data: CredentialsResult | null;
};

/**
 * Sole data source for the Credentials page: `trpc.credentials.getMyCredentials`.
 * That endpoint already resolves status/category/requirement/completeness
 * server-side from the new credential model, so this hook is a thin fetch —
 * no legacy field/file queries, no client-side re-classification.
 */
export function useCredentials(userId: string): UseCredentialsResult {
  const trpc = useTRPC();

  const query = useQuery(
    trpc.credentials.getMyCredentials.queryOptions({ switchUserId: userId }),
  );

  return {
    isLoading: query.isLoading,
    error: query.error,
    data: query.data ?? null,
  };
}
